module.exports = __webpack_public_path__ + "static/media/wheel.156ebe84.mp3";